import layout1, { type Layout1ConfigDefaultsType } from "./layout1/Layout1Config";

/**
 * Definição de tipo para os defaults de layout de tema.
 */
export type themeLayoutDefaultsProps = Layout1ConfigDefaultsType;

/**
 * Definição de tipo para o layout de tema.
 */
export type themeLayoutProps = {
	defaults: themeLayoutDefaultsProps;
};

/**
 * Definição de tipo para as configs de layouts de tema.
 */
export type themeLayoutConfigsProps = Record<string, themeLayoutProps>;

/**
 * Configurações dos layouts de tema.
 */
const themeLayoutConfigs: themeLayoutConfigsProps = {
	layout1: layout1,
};

export default themeLayoutConfigs;
